import React from 'react';
import { TableData, TableRow } from '@cokitchen/cokitchen-components';
import SelectDropdown from 'components/base/select-dropdown';
import EditableInput from 'components/base/editable-input';
import useDashboardContext from 'contexts/dashboard.context';

type EmptyStoreItemRowProps = {
  vendorName: string;
  vendorIndex: number;
  onAddStoreItemToVendor: (vendorIndex: number, ingredientId: string) => void;
};

const EmptyStoreItemRow: React.FC<EmptyStoreItemRowProps> = ({
  vendorName,
  vendorIndex,
  onAddStoreItemToVendor
}) => {
  const { formStoreItems } = useDashboardContext();

  return (
    <TableRow className='hover:bg-gray-50 transition-colors'>
      <TableData className='px-2 py-2 text-sm text-gray-800'>{vendorName}</TableData>

      <TableData className='px-2 py-2 text-sm text-gray-800'>
        <div className='border border-red-5'>
          <SelectDropdown
            placeholder='Select ingredient'
            value=''
            setValue={(ing) => onAddStoreItemToVendor(vendorIndex, ing.id)}
            options={formStoreItems}
          />
        </div>
      </TableData>

      <TableData className='px-2 py-2 text-sm text-gray-800'>
        <EditableInput
          isEditing={false}
          type='number'
          value=''
          placeholder='Enter price'
          disabled
        />
      </TableData>

      <TableData className='px-2 py-2 text-sm text-gray-400'>
        <span className='text-xs'>Select ingredient first</span>
      </TableData>
    </TableRow>
  );
};

export default EmptyStoreItemRow;
